document.addEventListener('DOMContentLoaded', function() {
    // Substituir "gorjeta" por "gratificação" em todos os textos
    const replaceGorjeta = (element) => {
        if (element.childNodes.length > 0) {
            element.childNodes.forEach(replaceGorjeta);
        } else if (element.nodeType === Node.TEXT_NODE) {
            element.nodeValue = element.nodeValue.replace(/gorjeta/gi, 'gratificação');
        }
    };

    // Aplica a substituição em todo o corpo da página
    replaceGorjeta(document.body);
});
